import { Api } from './api';

export class ActionPromptsApi {
    private static readonly PATH = '/action-prompts';

    constructor(private readonly m_api: Api) {}

    public async complete() {
        return this.m_api.post(`${ActionPromptsApi.PATH}/complete`, {});
    }
}